import { memo, useMemo } from "react";

import { formatDate } from "@/lib/dayjs/format-date";

type Props = {
	createdAt: number;
	updatedAt: number;
};

export const DatesOfManagementStatusCompositions = memo(({ createdAt: _createdAt, updatedAt: _updatedAt }: Props) => {
	/**
	 * 予約成立日時
	 */
	const createdAtText = useMemo(
		() => formatDate(new Date(_createdAt).toString(), "YYYY年MM月DD日 HH時mm分ss秒"),
		[_createdAt],
	);
	/**
	 * 更新日時
	 */
	const updatedAtText = useMemo(
		() => formatDate(new Date(_updatedAt).toString(), "YYYY年MM月DD日 HH時mm分ss秒"),
		[_updatedAt],
	);
	/**
	 * 更新日時の表示制御
	 */
	const canShowUpdatedAt = useMemo(() => _createdAt !== _updatedAt, [_createdAt, _updatedAt]);

	return (
		<div className="space-y-1">
			<div className="flex w-full max-w-md flex-wrap justify-between gap-x-5 border-b  border-zinc-200 p-2 text-sm">
				<p>予約成立日時</p>

				<p className="font-medium">{createdAtText}</p>
			</div>

			{canShowUpdatedAt && (
				<div className="flex w-full max-w-md flex-wrap justify-between gap-x-5 border-b  border-zinc-200 p-2 text-sm">
					<p>最終更新日時</p>

					<p className="font-medium">{updatedAtText}</p>
				</div>
			)}
		</div>
	);
});
